module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTg0OCAxNjBhNDggNDggMCAwIDAgMC05NmgtNjcyYTQ4IDQ4IDAgMCAwIDAgOTZoNjcyek02MDggOTYwYTMyIDMyIDAgMCAwIDMyLTMyVjU0NGgxNTYuOGEzMiAzMiAwIDAgMCAyMi42LTU0LjZsLTI4NC44LTI4NC44YTMyIDMyIDAgMCAwLTQ1LjIgMGwtMjg0LjggMjg0LjhBMzIgMzIgMCAwIDAgMjI3LjIgNTQ0SDM4NHYzODRhMzIgMzIgMCAwIDAgMzIgMzJoMTkyeiIgZmlsbD0iIzAiIHAtaWQ9IjMwNzMiPjwvcGF0aD48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Up to top-filled.svg
// module id = BcpE
// module chunks = 73